<template>
  <div class="body-wrapper">
    <Headernav />
    <div class="w-full bg-orange-100">
      <div class="section">
        <div class="container text-center">
          <div class="text-title font-bold text-3xl text-gray-800 mb-3">MESSAGE SENDING SUCCESSFUL!</div>
          <div class="text-common text-gray-600 mb-12">Thank you for your kind interest in Alpha Design & Construction Sdn Bhd. We will get back to you as soon as possible.</div>
          <div class="btn-width m-auto"><router-link class="m-auto" to="/"><div class="orange-btn">Back To Home</div></router-link></div>
        </div>
      </div>
    </div>
    <div class="w-full section common-bg">
      <div class="container md:flex mb-8 lg:mb-12">
        <div class="w-full md:w-4/12 text-center pb-5 lg:pb-0">
          <img class="m-auto pb-4" src="/images/icon-tel.png" alt="icon tel">
          <a href="tel:010-2721682" target="_blank" class="text-lg hover:text-orange-500">010 - 272 1682</a>
        </div>
        <div class="w-full md:w-4/12 text-center pb-5 lg:pb-0">
          <img class="m-auto pb-4" src="/images/icon-map.png" alt="icon maps">
          <span class="text-lg">B-3-26, Plaza Arkadia, No.3, Jalan Intisari Perdana, Desa ParkCity, 52200 Kuala Lumpur.</span>
        </div>
        <div class="w-full md:w-4/12 text-center pb-5 lg:pb-0">
          <img class="m-auto pb-4" src="/images/icon-mail.png" alt="icon mail">
          <a href="mailto:enquiry@alphadesign.com.my" target="_blank" class="text-lg hover:text-orange-500">enquiry@alphadesign.com.my</a>
        </div>
      </div>
      <div class="container">
        <div class="w-full">
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7967.240711864092!2d101.636757!3d3.194051!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x45cfdda36fe068d4!2sAlpha%20Design%20%26%20Construction%20Sdn%20Bhd!5e0!3m2!1sen!2smy!4v1593585177765!5m2!1sen!2smy" width="100%" height="380" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias for src
import Headernav from '@/components/Headernav.vue'
export default {
  components: {
    Headernav
  },
  mounted () {
  }
}
</script>
<style>
</style>
